export enum ModuleNames {
  COMPANY_MANAGEMENT = 'Company Management',
  CONTROL_CENTER = 'Control Center',
  HUMAN_RESOURCES = 'Human Resources',
  TIME_TRACKING = 'Time Tracking',
}
